import { useEffect } from 'react';
import './FluencyComparisonGrid.css';

const FluencyComparisonGrid = () => {
  const appsData = [
    {
      app: "The iSpeakWell Project",
  techniques:
    "35+ self-practice tools combining YouTube-based micro-listening drills, Fluentize! repeat cycles, phoneme-level comparison, AI-generated CEFR speaking tasks, image description challenges, Culture-based content exploration, text-to-speech practice, and guided speech planning.",
    
  aiIntegration:
    "OpenAI GPT-4o conversational partner; AI speaking-task generator; phoneme analysis engine; real-time viseme avatar; AI pronunciation and fluency scoring; automated coaching tips; AI-driven story building and speaking task planner.",
    
  immersion:
    "Authentic YouTube segments, real video transcripts, learner-controlled playlists, scroll-based training demos, avatar-led lessons, and optional live community conversation rooms.",
    
  uniqueFeatures:
    "Full Fluency Funnel (Training Lab → Fluency Arena → Assessment); 35 solo-training functions; Fluentize! looping engine; speech visualizers; CEFR-level AI task creator; avatar in Tesla Bot mode; token economy for live rooms; ability to join or open free or premium speaking rooms; pathway to podcast participation for Pro graduates.",
    
  feedback:
    "Instant AI-driven pronunciation scoring, phoneme comparison, fluency assessment, TTS accuracy checks, visual speech meters, AI coaching comments, and long-form learner progress dashboards.",
    
  additional:
    "A hybrid system combining private self-training, community conversation practice, structured fluency assessment plans, and podcast participation. Designed as a step-by-step funnel that moves learners from silent study to confident spoken performance."
    },
    {
      app: "Duolingo",
      techniques: "Speech recognition; pronunciation drills; Roleplay conversations",
      aiIntegration: "GPT-4 powered AI roleplay (real-time dialogue)",
      immersion: "Scenario-based conversations",
      uniqueFeatures: "Gamified interactions; Personalized AI feedback",
      feedback: "Immediate AI-driven corrections",
      additional: "Historically translation-focused, expanding fluency features"
    },
    {
      app: "Rosetta Stone",
      techniques: "Immersive no-translation practice; TruAccent speech recognition",
      aiIntegration: "Proprietary speech recognition; AI pronunciation evaluation",
      immersion: "Immersion method; live tutoring",
      uniqueFeatures: "Early accurate pronunciation emphasis; adjustable sensitivity",
      feedback: "Instant pronunciation corrections; human feedback",
      additional: "Speaking from first lessons"
    },
    {
      app: "Babbel",
      techniques: "Real-life dialogues; guided speaking tasks",
      aiIntegration: "AI conversation partner (adaptive chatbot)",
      immersion: "Real scenario simulations",
      uniqueFeatures: "Tap-to-Translate; editable speech corrections",
      feedback: "Personalized post-conversation feedback",
      additional: "Guided to free-form conversation progression"
    },
    {
      app: "Busuu",
      techniques: "Recorded speech; community feedback",
      aiIntegration: "AI-driven conversations (speech-only)",
      immersion: "Peer interactions; realistic scenarios",
      uniqueFeatures: "Community speaking feedback; curriculum integration",
      feedback: "Detailed AI and peer corrections",
      additional: "Social component; required speaking tasks"
    },
    {
      app: "Mondly",
      techniques: "AI chatbot; AR/VR practice; interactive audio",
      aiIntegration: "Speech recognition AI chatbot",
      immersion: "AR/VR real-world simulations",
      uniqueFeatures: "AR/VR immersion; hands-free audio mode",
      feedback: "Real-time pronunciation corrections",
      additional: "Immersive speaking practice"
    },
    {
      app: "Memrise",
      techniques: "AI chatbot; native speaker videos",
      aiIntegration: "GPT-3 chatbot (free-form dialogues)",
      immersion: "Videos of native speakers",
      uniqueFeatures: "MemBot chatbot",
      feedback: "AI-driven vocabulary corrections",
      additional: "Natural conversation practice"
    },
    {
      app: "ELSA Speak",
      techniques: "AI pronunciation coaching",
      aiIntegration: "AI detailed speech analysis",
      immersion: "Pronunciation exercises",
      uniqueFeatures: "Advanced pronunciation corrections",
      feedback: "Instant detailed feedback",
      additional: "Specialized in accent improvement"
    },
    {
      app: "Italki/Preply/Cambly",
      techniques: "Live human conversation practice",
      aiIntegration: "None (human-based)",
      immersion: "Real conversations with native speakers",
      uniqueFeatures: "Personalized human tutoring",
      feedback: "Human-delivered personalized feedback",
      additional: "Authentic conversational practice"
    }
  ];

    useEffect(() => {
    const cards = document.querySelectorAll('.fluency-card');
    cards.forEach(card => {
        card.addEventListener('mousemove', e => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        card.style.setProperty('--x', `${x}px`);
        card.style.setProperty('--y', `${y}px`);
        });
    });
    }, []);

  return (
    <div className="fluency-card-grid">
      {appsData.map((app, index) => (
        <div className="fluency-card" key={index}>
          <h2 className="fluency-app-name">{app.app}</h2>
          <p><strong>Techniques:</strong> {app.techniques}</p>
          <p><strong>AI Integration:</strong> {app.aiIntegration}</p>
          <p><strong>Immersion:</strong> {app.immersion}</p>
          <p><strong>Unique Features:</strong> {app.uniqueFeatures}</p>
          <p><strong>Feedback Type:</strong> {app.feedback}</p>
          <p><strong>Notes:</strong> {app.additional}</p>
        </div>
      ))}
    </div>
  );
};

export default FluencyComparisonGrid;
